/**
 * Подсказки поиска в шапке (просьба владельца 29.10.2026): пока человек
 * печатает, под полем всплывают подходящие инструменты, а за ними —
 * готовые работы витрины. Чистый модуль: подбор инструментов
 * проверяется без браузера.
 */

/** Инструмент сайта: подпись уже на языке страницы. */
export interface Instrument {
  href: string;
  name: string;
}

/** Работа витрины в подсказке (/api/shared/podskazki). */
export interface PodskazkaRaboty {
  id: string;
  href: string;
  title: string;
  /** Обложка картинки или видео; пусто у текста и звука. */
  oblozhka: string;
  /** text, image, video, audio… */
  vid: string;
}

/** С какой длины запроса показывать подсказки. */
export const MIN_DLINA = 2;
const MAX_INSTRUMENTOV = 4;

const norm = (s: string) => s.toLowerCase().replace(/ё/g, 'е').trim();

/**
 * Инструменты по запросу: сначала те, чьё название начинается с запроса
 * или чьё слово начинается с него, затем совпадения внутри слова.
 * «сочин» → «Сочинение»; «аудио» → «Текст в аудио».
 */
export function podobratInstrumenty(q: string, vse: readonly Instrument[]): Instrument[] {
  const n = norm(q);
  if (n.length < MIN_DLINA) return [];
  const slova = n.split(/\s+/);
  const ves = (name: string): number => {
    const m = norm(name);
    if (m.startsWith(n)) return 0;
    if (
      m.split(/[\s-]+/).some((w) => w.startsWith(slova[0] ?? n)) &&
      slova.every((s) => m.includes(s))
    )
      return 1;
    if (m.includes(n)) return 2;
    return -1;
  };
  const vidennye = new Set<string>();
  return vse
    .map((i) => ({ i, v: ves(i.name) }))
    .filter(({ i, v }) => {
      if (v < 0 || vidennye.has(i.href)) return false;
      vidennye.add(i.href);
      return true;
    })
    .sort((a, b) => a.v - b.v)
    .slice(0, MAX_INSTRUMENTOV)
    .map(({ i }) => i);
}
